<script>
import LkCheckBoxBase from './LkCheckboxBase.vue'


export default {
  name: 'LkCheckbox',
  computed: {
    innerType () { return 'checkbox' },
    innerClass () { return 'checkbox-box' }
  },
  mixins: [
    LkCheckBoxBase
  ]
}
</script>
